<template>
  <el-dialog
      title="创建项目"
      :visible.sync="showDialog"
      width="650px"
      :append-to-body="true"
      :destroy-on-close="true"
      :before-close="cancel"
  >
    <div v-loading="loading" class="dialog-content" element-loading-text="加载中...">
      <!-- 按合同号带出项目号（项目号搜索在下方各平台项目下拉框里） -->
      <div class="project-search">
        <div class="project-search__header">
          <span class="project-search__title">按合同号搜索项目号</span>
          <span class="project-search__tip">
            输入合同号，查询{{ leftRightInfo.titles.left }} / {{ leftRightInfo.titles.right }}交付系统中的项目号；当对应系统中查询出来只有一条时将会自动填入
          </span>
        </div>
        <div class="project-search__bar">
          <el-input
              v-model.trim="contractNo"
              class="project-search__input"
              placeholder="请输入合同号"
              clearable
              @keyup.enter.native="searchProjects">
            <i slot="prefix" class="el-icon-search project-search__icon"></i>
          </el-input>
          <el-button size="small" type="success" icon="el-icon-search" :loading="searchLoading" @click="searchProjects">
            查询
          </el-button>
          <el-button v-if="searched" type="info"  plain  size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </div>

        <div v-if="searchLoading" class="project-search__empty">查询中，请稍候...</div>
        <template v-else-if="searched">
          <!-- 按交付系统 Tab 切换展示结果 -->
          <div class="project-search__tabs" role="tablist">
            <button
                v-for="group in searchGroups"
                :key="group.platform"
                type="button"
                role="tab"
                class="search-tab"
                :class="{ 'is-active': activeTab === group.platform }"
                @click="activeTab = group.platform">
              {{ group.title }}交付系统
              <em class="search-tab__count">{{ group.items.length }}</em>
<!--              <i v-if="selectedSides[group.platform]" class="el-icon-circle-check search-tab__ok"></i>-->
            </button>
          </div>

          <div class="result-list">
            <div v-if="!activeGroup.items.length" class="result-list__empty">
              没有查询到对应的项目
            </div>
            <div
                v-for="item in activeGroup.items"
                :key="activeTab + '-' + getProjectId(item)"
                class="result-item"
                :class="{ 'result-item--active': isCurrentProject(activeTab, item) }"
                tabindex="0"
              >
              <div class="result-item__main">
                <span class="result-item__id">{{ getProjectId(item) }}</span>
                <span class="result-item-info">
                  <span class="result-item__meta">合同号：{{ getContractNumber(item) || contractNo }}</span>
                  <span class="result-item__meta" v-if="getProjectType(item)">类型：{{ getProjectType(item) }}</span>
                </span>
              </div>
              <span v-if="isCurrentProject(activeTab, item)" class="result-item__filled">
                <i class="el-icon-circle-check"></i> 已填入{{ activeGroup.title }}
              </span>
              <el-button v-else size="mini" class="result-item__fill" @click="onRowClick(item)">
                填入{{ activeGroup.title }}
              </el-button>
            </div>

          </div>
          <div class="result-summary">
            <span>
              共 {{ searchTotal }} 条结果（{{ leftRightInfo.titles.left }} {{ leftCount }} 条； {{ leftRightInfo.titles.right }} {{ rightCount }}条）
            </span>
<!--            <span class="result-summary__hint">点击整行可自动将项目号填入下方</span>-->
          </div>
        </template>
      </div>

      <el-form label-width="110px" :model="form" :rules="rules">
        <el-form-item>
          <template slot="label">
            <span class="addRequired">
              <span>{{ leftRightInfo.titles.left }}项目</span>
              <el-tooltip>
                <template slot="content">
                  <span>填写{{ leftRightInfo.titles.left }}交付系统中的项目号；<a class="tooltipLink"
                                                                                 @click="openProjectWeb(leftRightInfo.webUrls.left)">点击前往{{ leftRightInfo.titles.left }}交付系统</a></span>
                </template>
                 <i class="el-icon-question tooltipQuestion"></i>
              </el-tooltip>
            </span>
          </template>
          <ProjectAnalyzeBox
              v-model="form.leftInfo"
              :type="leftRightInfo.platNames.left"
              :example-project-id="leftRightInfo.exampleProjectIds.left"/>
        </el-form-item>

        <el-form-item>
          <template slot="label">
            <span class="addRequired">
              <span>{{ leftRightInfo.titles.right }}项目</span>
              <el-tooltip>
                <template slot="content">
                  <span>填写{{ leftRightInfo.titles.right }}交付系统中的项目号；<a class="tooltipLink"
                                                                                  @click="openProjectWeb(leftRightInfo.webUrls.right)">点击前往{{ leftRightInfo.titles.right }}交付系统</a></span>
                </template>
                 <i class="el-icon-question tooltipQuestion"></i>
              </el-tooltip>
            </span>
          </template>
          <ProjectAnalyzeBox
              v-model="form.rightInfo"
              :type="leftRightInfo.platNames.right"
              :example-project-id="leftRightInfo.exampleProjectIds.right"/>
        </el-form-item>
        <el-form-item label="备注（客户自填）" v-if="this.$store.getters['right/getRole'] === 'USER'">
          <el-input v-model="form.customerRemark" type="textarea" rows="2" placeholder="备注（客户自填）"/>
        </el-form-item>
        <el-form-item label="项目备注" v-else>
          <el-input v-model="form.remark" type="textarea" rows="2" placeholder="项目备注"/>
        </el-form-item>
      </el-form>

      <div slot="footer" style="text-align:right;margin-top: 5px">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit" :loading="buttonLoading">确认创建</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import CustomerInfo from "@/components/customer/CustomerInfo.vue";
import ProjectAnalyzeBox from "@/components/project/transMetabo/ProjectAnalyzeBox.vue";
import {addTransMetaboProject, editTransMetaboProject} from "@/api/transMetabo";
import {searchProject, pickRecords} from "@/api/project";

export default {
  components: {CustomerInfo, ProjectAnalyzeBox},
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    selectDetail: {
      type: Object,
      default: () => ({})
    },
    leftRightInfo: {
      type: Object,
      default: () => ({
        titles: {
          left: '转录组',
          right: '代谢组'
        },
        platNames: {
          left: 'trans',
          right: 'metabo'
        },
        exampleProjectIds: {
          left: 'transProjectXXXXXXXXXXXXXX',
          right: 'metaboProjectXXXXXXXXXXXXXX'
        },
        webUrls: {
          left: 'projectTrans',
          right: 'projectMetabo'
        }
      })
    },
  },
  data() {
    return {
      buttonLoading: false,
      form: {
        leftInfo: null,
        rightInfo: null,
        customerInfo: "",
        remark: "",
        customerRemark: "",
      },
      rules: {
      //   salesUuid: [
      //     {required: true, message: "选择转录代谢项目，自动填写", trigger: "blur"}
      //   ]
      },
      loading: false,
      // 合同号 -> 项目号
      contractNo: '',
      searchLoading: false,
      searched: false,
      searchGroups: [],
      // 结果区当前展示的交付系统 Tab
      activeTab: 'left',
      // leftSampleList: [],
      // rightSampleList: [],
    };
  },

  computed: {
    // 当前 Tab 对应的分组
    activeGroup() {
      return this.searchGroups.find(group => group.platform === this.activeTab)
          || { platform: this.activeTab, title: '', items: [] }
    },
    // 某侧命中的项目数（结果区汇总行用）
    leftCount() {
      const group = this.searchGroups.find(item => item.platform === 'left')
      return group ? group.items.length : 0
    },
    rightCount() {
      const group = this.searchGroups.find(item => item.platform === 'right')
      return group ? group.items.length : 0
    },
    // 两侧命中总数
    searchTotal() {
      return this.leftCount + this.rightCount
    }
  },

  methods: {
    cancel() {
      this.$emit("update:showDialog");
    },
    async submit() {
      const {leftInfo, rightInfo} = this.form;
      // 表单校验逻辑不变
      if (!leftInfo?.project?.projectsRow || !rightInfo?.project?.projectsRow) {
        this.$messageUi.error(`请选择${this.leftRightInfo.titles.left}和${this.leftRightInfo.titles.right}的项目`);
        return;
      }
      let sendData = {
        leftProjectId: leftInfo.project?.projectsRow.projectId,
        rightProjectId: rightInfo.project?.projectsRow.projectId,
        customerRemark: this.form.customerRemark,
        remark: this.form.remark,
      };
      this.buttonLoading = true
      try {
        // 封装emit为Promise，等待上层回调完成再往下走
        await new Promise((resolve, reject) => {
          this.$emit("submitData", sendData, (isSuccess) => {
            if (isSuccess) {
              resolve()
            } else {
              reject(new Error('创建项目失败，请检查参数'))
            }
          });
        })
        // 只有接口成功才会走到这里
        this.$messageUi.success('创建成功');
        this.$emit("update:showDialog");
      } catch (e) {
        // 捕获所有失败：接口异常/业务失败
        // this.$messageUi.error(e.message)
      } finally {
        // 等接口完全结束，再关闭loading
        this.buttonLoading = false
      }
    },
    openProjectWeb(webUrl) {
      window.open(`/${webUrl}`)
    },

    // ---------------- 按合同号搜索项目 ----------------
    getProjectId(item) {
      return (item && item.projectsRow && item.projectsRow.projectId) || ''
    },
    getContractNumber(item) {
      return (item && item.projectsRow && item.projectsRow.contractNumber) || ''
    },
    getProjectType(item) {
      const row = (item && item.projectsRow) || {}
      return row.projectType || row.projectSign || ''
    },
    currentInfo(platform) {
      return platform === 'left' ? this.form.leftInfo : this.form.rightInfo
    },
    isCurrentProject(platform, item) {
      const info = this.currentInfo(platform)
      const currentId = info && info.project ? this.getProjectId(info.project) : ''
      return !!currentId && currentId === this.getProjectId(item)
    },
    fillProject(platform, item) {
      const payload = { project: item }
      if (platform === 'left') {
        this.form.leftInfo = payload
      } else {
        this.form.rightInfo = payload
      }
      const title = platform === 'left' ? this.leftRightInfo.titles.left : this.leftRightInfo.titles.right
      this.$messageUi.success(`已自动填入${title}项目号：${this.getProjectId(item)}`)
    },
    // 点击整行填入；已经是当前已填的那条就不再重复处理（否则每次点都弹一次提示）
    onRowClick(item) {
      if (this.isCurrentProject(this.activeTab, item)) return
      this.fillProject(this.activeTab, item)
    },
    // 按合同号查：POST /project/search，body { projectId, contractNumber }
    // （项目号搜索请用下方各平台的项目下拉框）
    queryProjects(plat, contractNumber) {
      return Promise.resolve()
          .then(() => searchProject({ projectId: '', contractNumber: contractNumber }, plat))
          .then(res => pickRecords(res))
          .catch(() => [])
    },
    async searchProjects() {
      const contractNo = (this.contractNo || '').trim()
      if (!contractNo) {
        this.$messageUi.warning('请输入合同号')
        return
      }
      const platNames = this.leftRightInfo.platNames || {}
      this.searchLoading = true
      this.searched = false
      try {
        const [leftItems, rightItems] = await Promise.all([
          this.queryProjects(platNames.left, contractNo),
          this.queryProjects(platNames.right, contractNo)
        ])
        this.searchGroups = [
          { platform: 'left', title: this.leftRightInfo.titles.left, items: leftItems },
          { platform: 'right', title: this.leftRightInfo.titles.right, items: rightItems }
        ]
        this.searched = true
        this.autoFillUnique()
        // 哪一侧有结果就停在哪个 Tab，避免进来先看到空列表
        this.activeTab = leftItems.length ? 'left' : (rightItems.length ? 'right' : 'left')
      } catch (e) {
        this.$messageUi.error('查询失败，请稍后再试')
      } finally {
        this.searchLoading = false
      }
    },
    // 每个平台只查到唯一项目时直接带出，省一次点击
    autoFillUnique() {
      let filled = 0
      this.searchGroups.forEach(group => {
        if (group.items.length === 1) {
          const payload = { project: group.items[0] }
          if (group.platform === 'left') {
            this.form.leftInfo = payload
          } else {
            this.form.rightInfo = payload
          }
          filled++
        }
      })
      if (!this.searchTotal) {
        this.$messageUi.warning('未查询到对应的项目号')
      } else if (filled) {
        this.$messageUi.success(`已带出 ${filled} 个项目号`)
      }
    },
    resetSearch() {
      this.contractNo = ''
      this.searched = false
      this.searchGroups = []
      this.activeTab = 'left'
    }
  },
};
</script>

<style scoped>
/deep/ .el-dialog__body {
  padding-top:10px!important;
}

/deep/ .el-input__prefix{
  display: flex;
  align-items: center;
 }
.tooltipQuestion {
  color: #e58f0d;
  cursor: pointer;
}

.tooltipLink {
  color: #3f9dfe;
  cursor: pointer;
}

/* ---------------- 按合同号带出项目号 ---------------- */
.project-search {
  margin: 0 0 20px;
  padding: 16px 18px 5px;
  border: 1px solid #dde9fd;
  border-radius: 10px;
  background: linear-gradient(#f0f7fd 0%, #f6fafd 100%);
}

.project-search__header {
  margin-bottom: 14px;
}

.project-search__title {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  border-left: 3px solid #3f9dfe;
  padding-left: 8px;
}

.project-search__tip {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #909399;
}

.project-search__bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.project-search__input {
  //width: 450px;
}

.project-search__icon {
  line-height: 32px;
  color: #3f9dfe;
}

.project-search__empty {
  padding: 20px 0 6px;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

/* 交付系统 Tab：等宽分段控件 */
.project-search__tabs {
  display: flex;
  gap: 4px;
  margin-top: 16px;
  padding: 3px;
  border-radius: 8px;
  background: #e9f1fd;
}

.search-tab {
  flex: 1;
  //display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 550;
  color: #494949;
  cursor: pointer;
  transition: background-color .2s, color .2s, box-shadow .2s;
}

.search-tab:hover {
  color: #303133;
}

.search-tab.is-active {
  background: #fff;
  color: #2e77e3;
  //color: #303133;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(19, 32, 56, .14);
}

.search-tab__count {
  padding: 1px 5px;
  border-radius: 10px;
  background: rgba(202, 221, 250, 0.96);
  color: #3f9dfe;
  font-size: 11px;
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  text-align: center;
}

.search-tab.is-active .search-tab__count {
  background: #3f9dfe;
  color: #fff;
}

.search-tab__ok {
  color: #4c9c2a;
}

/* 当前 Tab 的项目列表：区域内滚动，滚动条做细 */
.result-list {
  //margin-top: 12px;
  max-height: 185px;
  overflow-y: auto;
  border: 1px solid #eaeff5;
  border-radius: 8px;
  background: #fff;
  padding: 4px 6px;
  scrollbar-width: thin;
}

.result-list::-webkit-scrollbar {
  width: 6px;
}

.result-list::-webkit-scrollbar-thumb {
  background: #d6e9eb;
  border-radius: 3px;
}

.result-list::-webkit-scrollbar-thumb:hover {
  background: #bfe0e3;
}

.result-list::-webkit-scrollbar-track {
  background: transparent;
}

.result-list__empty {
  padding: 20px 2px;
  text-align: center;
  font-size: 12px;
  color: #c0c4cc;
}

/* 结果汇总行：条数统计 + 操作提示 */
.result-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
  font-size: 12px;
  color: #909399;
}

.result-summary__hint {
  color: #b7bcc4;
}

.result-summary__hint::before {
  content: '·';
  margin-right: 6px;
  color: #d4d8de;
}

/* 项目号条目：两行 —— 第一行项目号，第二行灰色补充信息，右侧操作；整行可点入 */
.result-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 5px 10px;
  border-bottom: 1px dashed #c9d8f3;
  cursor: pointer;
  outline: none;
  transition: background-color .2s;
}

.result-item:last-child {
  border-bottom: none;
}

/* 未填入：hover / 键盘聚焦浅蓝 */
.result-item:hover,
.result-item:focus-visible {
  background: #f2f8ff;
}

/* 已填入：浅绿底 + 绿字，和未填入的蓝色按钮一眼区分；已是当前值，不再响应点击 */
.result-item--active {
  background: #f1faf2;
  border-bottom-color: transparent;
  cursor: default;
}

.result-item--active:hover {
  background: #e9f7ec;
}

/* 已填入：项目号、合同号、类型一起转绿（补充信息浅一档，保持主次层级） */
.result-item--active .result-item__id {
  color: #4c9c2a;
}

.result-item--active .result-item__meta {
  color: #6ba644;
}

.result-item__main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1;
  min-width: 0; /* 配合省略号，长项目号不把右侧按钮挤出去 */
}

.result-item__id {
  max-width: 100%;
  font-size: 13px;
  color: #515152;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 微软雅黑;
}

.result-item-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
  max-width: 100%;
}

.result-item__meta {
  font-size: 12px;
  color: #9599a1;
  white-space: nowrap;
}

/* 未填入：描边小按钮 —— 可点击 */
.result-item .result-item__fill {
  flex: none;
  padding: 4px 12px;
  font-size: 12px;
  line-height: 1.4;
  color: #3f9dfe;
  background: #fff;
  border: 1px solid #9dc7fd;
  border-radius: 4px;
  transition: color .2s, background-color .2s, border-color .2s;
}

.result-item .result-item__fill:hover,
.result-item .result-item__fill:focus {
  color: #fff;
  background: #3f9dfe;
  border-color: #3f9dfe;
}

/* 已填入：绿色文字 + 对勾，不可点 */
.result-item__filled {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: none;
  color: #4c9c2a;
  font-size: 12px;
  white-space: nowrap;
}
</style>
